<template>
	<!-- CARDS FOR CAMERA BODY - MAIN CAMERA -->
	<a target="_blank" :href="gearLink" class="aup-gear " v-if="isMainCamera">
		<div class="aup-gear__gear-container d-flex p-xl-5 p-4 w-100">
			<div class="aup-gear__gear-item row w-100 no-gutters">
				<figure
					class="mb-0 d-flex align-items-center col-12 text-center col-md-8"
				>
					<img
						:src="image"
						class="aup-gear__image img-fluid"
						style="flex-grow: 1;"
						alt="Camera image"
					/>
				</figure>
				<div
					class="d-flex flex-column justify-content-center align-items-center col-12 col-md-4"
				>
					<h3 class="aup-gear__title h1 text-center">error:call:0</h3>
					<div class="aup-gear__link-text text-align-center">
						View on Sony.com
					</div>
					<div
						class="aup-gear__arrow-container aup-gear__arrow-container--center"
					>
						<div class="aup-gear__arrow-slider">
							<svg
								class="aup-gear__arrow"
								xmlns="http://www.w3.org/2000/svg"
								width="64"
								height="10"
							>
								<path d="M0 5h56.8" />
								<path d="M55.4 10L64 5l-8.6-5z" />
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	</a>

	<!-- CARDS FOR LENSES -->
	<a
		target="_blank"
		:href="gearLink"
		class="aup-gear mb-4 col-6 col-lg-4 col-xl-3"
		v-else-if="lens"
	>
		<div class="aup-gear__gear-container d-flex p-4 p-lg-5 w-100">
			<div class="aup-gear__gear-item w-100 mx-auto">
				<figure class="text-center">
					<img :src="image" class="aup-gear__image img-fluid" alt="Lens image" />
				</figure>
				<div class="d-flex flex-column pt-4">
					<h3 class="aup-gear__title aup-gear__title--lens">error:call:1</h3>
					<span class="aup-gear__link-text">View on Sony.com</span>
					<div class="aup-gear__arrow-container">
						<div class="aup-gear__arrow-slider">
							<svg
								class="aup-gear__arrow"
								xmlns="http://www.w3.org/2000/svg"
								width="64"
								height="10"
							>
								<path d="M0 5h56.8" />
								<path d="M55.4 10L64 5l-8.6-5z" />
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	</a>

	<!-- CARDS FOR CAMERAS THAT ARENT MAIN BODY -->
	<a target="_blank" :href="gearLink" class="aup-gear" v-else>
		<div class="aup-gear__gear-container d-flex p-5 w-100">
			<div class="aup-gear__gear-item w-100 mx-auto">
				<figure class="text-center mb-0">
					<img
						:src="image"
						class="aup-gear__image img-fluid"
						style="flex-grow: 1;"
						alt="Camera image"
					/>
				</figure>
				<div
					class="d-flex flex-column align-items-center pt-4"
					style="flex-grow: 1;"
				>
					<h3 class="aup-gear__title">error:call:2</h3>
					<span class="aup-gear__link-text">View on Sony.com</span>
					<div
						class="aup-gear__arrow-container aup-gear__arrow-container--center"
					>
						<div class="aup-gear__arrow-slider">
							<svg
								class="aup-gear__arrow"
								xmlns="http://www.w3.org/2000/svg"
								width="64"
								height="10"
							>
								<path d="M0 5h56.8" />
								<path d="M55.4 10L64 5l-8.6-5z" />
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	</a>
</template>
<script>
export default {
	name: 'BaseGearCard',
	components: {},
	props: {
		brand: {
			type: String,
			default: null,
		},
		name: {
			type: String,
			default: null,
		},
		model: {
			type: String,
			default: null,
		},
		image: {
			type: String,
			default: null,
		},
		isMainCamera: {
			type: Boolean,
			default: false,
		},
		lens: {
			type: Boolean,
			default: false,
		},
		gearLink: {
			type: String,
			default: 'https://electronics.sony.com',
		},
	},
	method: {},
};
</script>
<style lang="scss">
@import '../../assets/scss/all';

.aup-gear {
	//   background-color: $white;
	//   margin: 1rem;
	//   padding: 2rem;
	text-decoration: none;
	color: $black;
	transition: transform 0.3s ease-in-out;

	&__image {
		object-fit: contain;
	}
	&__title {
		&--lens {
			@include media-breakpoint-down(lg) {
				font-size: $h5-font-size;
			}
		}
	}
	&__gear-container {
		position: relative;
		background-color: $white;
		height: 100%;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease-in-out;

		&::after {
			content: '';
			position: absolute;
			z-index: -1;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
			box-shadow: 0 5px 8px 2px rgba(0, 0, 0, 0.15);
			opacity: 0;
			transition: opacity 0.3s ease-in-out;
		}

		&:hover::after {
			opacity: 1;
		}
	}
	&__arrow-container {
		position: relative;
		display: inline-block;
		height: 10px;
		width: 64px;
		overflow: hidden;

		&--center {
			transform: translateX(25%);
			transition: transform 0.3s ease-in-out;
		}
	}
	&__arrow-slider {
		position: absolute;
		left: -32px;
		top: 50%;
		transform: translateY(-50%);
		transition: left 0.3s ease-in-out;
	}
	&__arrow {
		display: block;
		fill: $primary;
		stroke-miterlimit: 500;
		path:first-child {
			stroke: $primary;
		}
		// margin-left: 32px;
	}

	&__link-text {
		font-family: $font-family-regular;
		margin-bottom: 12px;
		opacity: 0;
		color: $primary;
		transform: translateX(-32px);
		transition: all 0.35s ease-in-out;
	}

	&:hover {
		transform: translateY(-8px);
		text-decoration: none;
		color: $primary;

		.aup-gear__arrow-container--center {
			transform: translateX(0);
		}

		.aup-gear__link-text {
			transform: translateX(0);
			opacity: 1;
		}
	}
	&:hover .aup-gear__arrow-container {
		// visibility: visible;
	}
	&:hover .aup-gear__arrow-slider {
		left: 0;
	}
}
</style>
